export const FUSE_EDIT_TABLE = {
  tableName: 'Fuses',
  editColumnName: 'value',
  defaultValueColumnName: 'defaultValue',
  searchColumnName: 'name',
  columns: [
    {
      field: 'name',
      headerName: 'Fuse Name',
      editable: false,
      flex: 1,
      minWidth: 250,
      resizable: false,
    },
    {
      field: 'value',
      headerName: 'Fuse Value',
      editable: true,
      flex: 0.5,
      minWidth: 150,
      resizable: false,
    },
    {
      field: 'width',
      headerName: 'Fuse Width',
      editable: false,
      flex: 0.5,
      minWidth: 150,
      resizable: false,
    },
  ],
  tableTitle: '',
  tableKey: 'fuseEdit',
};

export const STRAP_EDIT_TABLE = {
  tableName: 'Straps',
  editColumnName: 'value',
  defaultValueColumnName: 'defaultValue',
  searchColumnName: 'name',
  columns: [
    {
      field: 'name',
      headerName: 'Strap Name',
      editable: false,
      flex: 1,
      minWidth: 250,
      resizable: false,
    },
    {
      field: 'value',
      headerName: 'Strap Value',
      editable: true,
      flex: 0.5,
      minWidth: 150,
      resizable: false,
    },
    {
      field: 'width',
      headerName: 'Strap Width',
      editable: false,
      flex: 0.5,
      minWidth: 150,
      resizable: false,
    },
  ],
  tableTitle: '',
  tableKey: 'strapEdit',
};
